import React from 'react';
import PropTypes from 'prop-types';
import { StyledInput } from './styles.js';

// Auto complete types taken from
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
const autoCompleteValues = {
  title: 'honorific-prefix',
  firstName: 'given-name',
  lastName: 'family-name',
  company: 'organization',
  organisation: 'organization',
  jobTitle: 'organization-title',
  phoneNumber: 'tel',
  email: 'email',
};

const TextField = React.forwardRef(
  ({ error, short, autoComplete, ...rest }, ref) => {
    // autoComplete for address, postcode &  date-of-birth fields are within their specific files src\components\form-elements

    // the below avoids overriding autoComplete for other text-field types that have already been set in their specific files, e.g. postcode & query (search)
    const autoCompleteValue =
      autoComplete || autoCompleteValues[rest.name] || 'on';

    return (
      <StyledInput
        {...rest}
        label={null}
        ref={ref}
        data-input-scroll-id={rest.name}
        $error={error}
        $short={short}
        autoComplete={autoCompleteValue}
      />
    );
  }
);

TextField.propTypes = {
  type: PropTypes.oneOf([
    'text',
    'password',
    'email',
    'number',
    'tel',
    'search',
  ]),
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  error: PropTypes.bool,
  short: PropTypes.bool,
};

TextField.displayName = 'TextField';

TextField.defaultProps = {
  type: 'text',
};

export default TextField;
